(function (module) {
  'use strict';
  module.directive('fileinputListener', function() {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      var onChangeHandler = scope.$eval(attrs.fileinputListener);
      element.bind('change', onChangeHandler);
    }
  };
});
})(angular.module('obex'));



// WEBPACK FOOTER //
// ./client/js/directives/fileinputListener.directive.js